/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('CureItem_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/cureItems/:id' , {} ,
            {
                query: { method: 'GET', isArray: true },
                get:   { method: 'GET' },
                getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/cureItems/deleted'},
                checkCureItemServicesIsUsed : { method: 'POST', url:baseUrl+'rest/cureItems/cureItemToService/checkCureItemServicesIsUsed'} ,
            }
        );
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CureItem',["CureItem_Resource","CureItemData","CureItemToService",
        function (CureItem_Resource,CureItemData,CureItemToService)
    {

        var CureItem = function (resource,saleCure,mustloadElements)
        {
            this.id = null;
            this.isDeleted=false;
            this.saleCure = saleCure;
            this.cureItemToServices = [];
            this.isClosed = false;
            this.cureUsed = true;
            this.version = null;
            if (resource !== undefined && resource != null)
            {
                this.loadObjectProperties(resource);
                if (mustloadElements)
                    this.loadObjectCureItemToServices(resource);

            }
            CureItemData.add(this);
        }
        CureItem.prototype.loadObjectProperties = function(object)
        {
            //Assume here than the object in parameter contains only id (must load them)
            if (!this.id)
                this.id = object.id;
            if (object.version)
                this.version = object.version;
            this.isDeleted = object.isDeleted;
            if (object.isClosed !==undefined)//new
                this.isClosed = object.isClosed;
        };
        CureItem.prototype.loadObjectCureItemToServices = function(object)
        {
            this.cureItemToServices = []
            if (object.cureItemToServices)
                for (var i=0;i<object.cureItemToServices.length;i++)
                    this.cureItemToServices.push(new CureItemToService(object.cureItemToServices[i],this,true))
        };
        CureItem.prototype.getObjectResource = function()
        {
            var rsCureItem = new CureItem_Resource();
            rsCureItem.id = this.id;
            rsCureItem.isDeleted = this.isDeleted;
            rsCureItem.isClosed = this.isClosed;
            rsCureItem.cureItemToServices = [];
            if (this.cureItemToServices)
                for (var i=0;i<this.cureItemToServices.length;i++)
                    rsCureItem.cureItemToServices.push(this.cureItemToServices[i].getObjectResource());

            return rsCureItem;
        } ;

        CureItem.prototype.loadRef =  function()
        {
            //no action
        };

        CureItem.prototype.getId = function()
        {
            return this.id;
        };
        CureItem.prototype.setId = function(id)
        {
            this.id = id;
        };
        CureItem.prototype.addCureItemToService = function(cureItemToService)
        {
            if (cureItemToService)
            {
                var index = this.cureItemToServices.indexOf(cureItemToService);
                if (index==-1)
                    this.cureItemToServices.push(cureItemToService);
                cureItemToService.cureItem = this;
            }
        };
        CureItem.prototype.removeCureItemToService = function(cureItemToService)
        {
            if (cureItemToService)
            {
                var index = this.cureItemToServices.indexOf(cureItemToService);
                if (index!=-1)
                    this.cureItemToServices.splice(index,1);
                cureItemToService.cureItem=null;
            }
        };
        CureItem.prototype.isUsed = function()
        {
            var isUsed = true;
            for (var i=0;i<this.cureItemToServices.length && isUsed;i++)
                isUsed = isUsed &&  this.cureItemToServices[i].isUsed();
            return isUsed || this.isClosed;
        };
        return CureItem;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CureItemSrv',["$log","CureItem_Resource","CureItem","UserActionData","CureItemData","ServerSrv","SaleCureData",
        function ($log,CureItem_Resource,CureItem,UserActionData,CureItemData,ServerSrv,SaleCureData)
    {
        var  cureItemSrv =
        {};
        cureItemSrv.save =  function(cureItem,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(cureItemSrv.saveSync, cureItem, successFunction, errorFunction);
        };
        cureItemSrv.saveSync = function(cureItem,successFunction,errorFunction)
        {
            //$timeout (function () {

            var CureItemRes = cureItem.getObjectResource();
            CureItemRes.$save({}, //no params
                function (data) {
                    try{
                        if(cureItem.id == null) {
                            cureItem.setId(data.id);
                        }
                        if (!cureItem.version || (data.version && data.version > cureItem.version))
                            cureItem.version = data.version;
                        /** @namespace data.supplierId */
                        if (data.supplierId && cureItem.supplier)
                            cureItem.supplier.id = data.supplierId;

                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        cureItemSrv.remove =  function(cureItem,successFunction,errorFunction)
        {
            CureItemData.remove(cureItem);
            ServerSrv.startSavingProcess(cureItemSrv.removeSync, cureItem, successFunction, errorFunction);
        };
        cureItemSrv.removeSync =  function(cureItem,successFunction,errorFunction)
        {
            //$timeout (function () {

            var cureItemRes = new CureItem_Resource();
            cureItemRes.$remove({id:cureItem.getId()}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        cureItemSrv.restore =  function(cureItem,successFunction,errorFunction)
        {
            CureItemData.restore(cureItem);
            ServerSrv.startSavingProcess(cureItemSrv.restoreSync, cureItem, successFunction, errorFunction);
        };
        cureItemSrv.restoreSync =  function(cureItem,successFunction,errorFunction)
        {
            //$timeout (function () {

            var cureItemRes = cureItem.getObjectResource();
            cureItemRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        cureItemSrv.query = function(successFunction,errorFunction)
        {
            CureItem_Resource.getDeleted(
                {}, //params
                function (data) {   //success

                    CureItemData.deletedCureItems = [] ;
                    for (var i=0;i< data.length;i++)
                        new CureItem(data[i]);//Auto Add to CureItemData

                    if (successFunction!== undefined )
                        successFunction(CureItemData.categoryRoot);
                },
                function (data) {   //failure
                    $log.error("CureItem_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);

                });
        };

        cureItemSrv.checkCureItemServiceIsUsed = function(cureItemsToService,successFunction,errorFunction)
        {
            let cureItemRessource = new CureItem_Resource();
            cureItemRessource.cureItemServices = cureItemsToService;
            cureItemRessource.$checkCureItemServicesIsUsed({},
                function (data) {
                    if (successFunction != undefined)
                        successFunction(data);
                },
                function (data) {
                   if (errorFunction != undefined)
                       errorFunction(data);

                }
            );
        };

        cureItemSrv.loadRef =  function()
        {
            var cureItems = CureItemData.indexCureItems;
            for (var i=0;i<cureItems.length;i++)
                cureItems[i].loadRef();

        };

        cureItemSrv.updateLocally =  function(id,resource)
        {
            var cureItem = CureItemData.getById(id);
            if (cureItem!=null)
            {
                cureItem.loadObjectProperties(resource);
                cureItem.loadRef();
            }
            return cureItem
        };
        cureItemSrv.addLocally =  function(id,resource)
        {
            var cureItem = CureItemData.getById(id);
            if (cureItem!=null)
                cureItem.loadObjectProperties(resource);
            else
            {
                cureItem = new CureItem(resource,null,false);
                cureItem.id = id;
            }
            cureItem.loadRef();
            if (resource.saleCureId)
            {
                var saleCure = SaleCureData.getById(resource.saleCureId);
                if (saleCure)
                    saleCure.addCureItem(cureItem);
            }
            return cureItem;
        };
        cureItemSrv.removeLocally =  function(id,resource)
        {
            var cureItem = CureItemData.getById(id);
            if (cureItem!=null)
            {
                //remove from sale
                if(cureItem.saleCure)
                    cureItem.saleCure.removeCureItem(cureItem);
            }
            return cureItem;
        };

        return cureItemSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CureItemData',["$log", function ($log)
    {
        var  cureItemData =
        {
            indexCureItems : [], //Used as Index
            deletedCureItems : []
        };
        cureItemData.getById =  function(cureItemId)
        {
            for (var i=0;i<this.indexCureItems.length;i++)
                if (this.indexCureItems[i].id==cureItemId)
                    return this.indexCureItems[i];
            return null;
        }
        cureItemData.getByIndex =  function(servIndex)
        {
            if (servIndex>=0 && servIndex<this.indexCureItems.length)
            {
                return this.indexCureItems[servIndex];
            }
            else
                return null;
        }
        cureItemData.getIndexOf =  function(cureItem)
        {
            if (cureItem)
                return this.indexCureItems.indexOf(cureItem);
            return -1;
        }
        cureItemData.add =  function(cureItem)
        {
            this.indexCureItems.push(cureItem);
            if (cureItem.isDeleted)
            {
                var index = this.deletedCureItems.indexOf(cureItem)
                if (index==-1)
                    this.deletedCureItems.push(cureItem);
            }
            return this.indexCureItems.length-1;
        }
        cureItemData.remove =  function(cureItem) //Soft Remove
        {
            var index =  this.deletedCureItems.indexOf(cureItem);
            if (index==-1)
            {
                this.deletedCureItems.push(cureItem)
                cureItem.isDeleted=true;
            }

        }
        cureItemData.restore =  function(cureItem) //Soft Remove
        {
            var index =  this.deletedCureItems.indexOf(cureItem);
            if (index!=-1)
            {
                this.deletedCureItems.splice(index,1)
                cureItem.isDeleted=false;
            }

        }
        cureItemData.clear =  function()
        {
            cureItemData.indexCureItems = [];
            cureItemData.deletedCureItems = [];
        }
        cureItemData.getDeletedList =  function()
        {
            return cureItemData.deletedCureItems;
        }

        return cureItemData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/CureItem.js